import { render } from "./EventDetails.vue?vue&type=template&id=d3d45d56"
import script from "./EventDetails.vue?vue&type=script&lang=js"
export * from "./EventDetails.vue?vue&type=script&lang=js"
script.render = render

export default script